import React from 'react'

import { useTranslation } from 'react-i18next'

import AlertCard from '@components/myScores/MessagesView/AlertCard'
import ExternalLink from '@components/shared/ExternalLink'
import { useSession } from '@stores/globalData/globalData.store'
import { formatPriceInCents } from '@utils/formatters/number.formatter'

import type AccountAlert from '@models/AccountAlert'

interface Props {
  alert: AccountAlert
}

const UpgradeAccountAlert: React.FC<Props> = ({ alert }: Props) => {
  const session = useSession()
  const { t } = useTranslation()
  const { subscription, communities_requiring_crescendo } = alert
  return (
    <AlertCard alert={alert}>
      {subscription ? (
        <>
          <p className="text-lg mb-2.5">
            {t('content.upgradedSubscription', {
              amount: formatPriceInCents(subscription.quote.initial_charge, {
                showDouble0ForCents: true,
              }),
            })}
          </p>
          <p className="mb-2.5">
            {t('content.enabledAccount', { planName: subscription.displayable_plan_name })}
          </p>
          {!!subscription.plan.max_scc_count && (
            <p className="mb-2.5">
              <span>{t('account.siteCount', { count: subscription.plan.max_scc_count })}</span>
              <span>
                {t('account.memberCount', { count: subscription.plan.max_scc_member_count })}
              </span>
              <span>{t('content.useSitesMenu')}</span>
            </p>
          )}
        </>
      ) : (
        <>
          <p className="mb-2.5">{t('content.upgradedAccount')}</p>
          {session.current_user?.can_create_site && (
            <p className="mb-2.5">{t('content.canCreateSites')}</p>
          )}
        </>
      )}

      {communities_requiring_crescendo.map((community) => (
        <p className="mb-2.5" key={community.id}>
          <span>{t('content.siteAccess')}</span>&nbsp;
          <ExternalLink href={`https://${community.hostname}`}>{community.name}</ExternalLink>.
        </p>
      ))}
    </AlertCard>
  )
}

export default UpgradeAccountAlert
